import React from 'react';
import { FaGripLines } from 'react-icons/fa';

const DragHandle = ({ listeners, attributes }) => (
  <FaGripLines {...listeners} {...attributes} data-drag-handle />
);

export default DragHandle;